import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_URL as CONFIG_API_URL } from '../../config';
const API_URL = CONFIG_API_URL || 'http://8.141.122.155:3002/api';


import { 
  FileText, Download, TrendingUp, AlertTriangle, 
  BarChart2, Target, Calendar, ChevronDown, Check,
  Shield, Layers, Activity, Search
} from 'lucide-react';
import {
  Chart as ChartJS, CategoryScale, LinearScale, PointElement,
  LineElement, BarElement, RadialLinearScale, ArcElement,
  Title, Tooltip, Legend, Filler
} from 'chart.js';
import { Line, Radar, Doughnut, Bar } from 'react-chartjs-2';
import ReactMarkdown from 'react-markdown';
import html2canvas from 'html2canvas';

ChartJS.register(
  CategoryScale, LinearScale, PointElement, LineElement, BarElement,
  RadialLinearScale, ArcElement, Title, Tooltip, Legend, Filler
);

export default function SeoCompare() {
  const [isGenerating, setIsGenerating] = useState(false);
  const [showReport, setShowReport] = useState(false);
  const [timeRange, setTimeRange] = useState('最近 30 天');

  const handleExportImage = async () => {
    const reportElement = document.getElementById('report-content');
    if (!reportElement) return;

    try {
      const canvas = await html2canvas(reportElement, {
        scale: 2,
        useCORS: true,
        backgroundColor: document.documentElement.classList.contains('dark') ? '#0f172a' : '#ffffff'
      });
      
      const image = canvas.toDataURL('image/png');
      const link = document.createElement('a');
      link.href = image;
      link.download = `SEO对比分析报告_${new Date().toISOString().slice(0, 10)}.png`;
      link.click();
    } catch (error) {
      console.error('Failed to export image', error);
    }
  };



    const [dashboardData, setDashboardData] = useState(null);
  
  const fetchReportData = async () => {
    setIsGenerating(true);
    try {
        const token = localStorage.getItem('token');
        const bid = localStorage.getItem('globalBrand');
        
        let urlParams = new URLSearchParams({
            system: 'seo',
            viewType: 'global',
            timeRange: timeRange === '自定义范围' ? 'custom' : timeRange
        });
        
        if (bid && bid !== 'all' && bid !== 'undefined') {
            urlParams.append('brandProjectId', bid);
        }
        
        // Calculate dates if needed
        let startDate, endDate;
        if (timeRange === '最近 7 天') {
            const start = new Date(); start.setDate(start.getDate() - 7); startDate = start.toISOString();
            endDate = new Date().toISOString();
        } else if (timeRange === '最近 30 天') {
            const start = new Date(); start.setDate(start.getDate() - 30); startDate = start.toISOString();
            endDate = new Date().toISOString();
        } else if (timeRange === '最近 90 天') {
            const start = new Date(); start.setDate(start.getDate() - 90); startDate = start.toISOString();
            endDate = new Date().toISOString();
        }
        if (startDate) urlParams.append('startDate', startDate);
        if (endDate) urlParams.append('endDate', endDate);

        const res = await axios.get(`${API_URL}/dashboard/insights?${urlParams.toString()}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        
        if (res.data.success && res.data.data) {
           setDashboardData(res.data.data);
           setShowReport(true);
        }
    } catch(e) {
        console.error("Failed to generate report", e);
    } finally {
        setIsGenerating(false);
    }
  };

  const handleGenerate = () => {
    fetchReportData();
  };

  // Derive data from API
  const radarDataRaw = dashboardData?.radarData || { labels: [], datasets: [] };
  const sovDataRaw = dashboardData?.sovData || { labels: [], datasets: [] };
  const sentimentRaw = dashboardData?.sentimentData || { labels: [], datasets: [] };
  
  const brands = sovDataRaw.labels || [];
  
  const radarData = {
    labels: radarDataRaw.labels || [],
    datasets: radarDataRaw.datasets || []
  };

  // SOV line chart can be mapped from realVisTrend or chartVisTrend
  const sovLineData = {
     labels: dashboardData?.realVisTrend?.labels || [],
     datasets: dashboardData?.realVisTrend?.datasets || []
  };
  
  // Transform sentiment into "Camp Bar" style
  // We have Positive, Neutral, Controversial, Negative in sentimentData
  const campBarData = {
    labels: sentimentRaw.labels || [],
    datasets: (sentimentRaw.datasets || []).map(ds => {
        let label = ds.label;
        if (label.includes('正向')) label = '正面口碑 / 本品占位';
        if (label.includes('负向')) label = '负面 / 吐槽 / 避坑';
        if (label.includes('中性')) label = '第三方中立评测';
        if (label.includes('争议')) label = '用户真实疑问';
        return {
            ...ds,
            label
        };
    })
  };
  
  let mainBrandName = '本品';
  const selfBrandFull = brands.find(b => b.includes('(本品)'));
  if (selfBrandFull) {
     mainBrandName = selfBrandFull.replace(' (本品)', '');
  } else if (brands[0]) {
     mainBrandName = brands[0];
  }
const optionsRadar = { 
    responsive: true, 
    maintainAspectRatio: false, 
    scales: { 
      r: { 
        beginAtZero: true, 
        max: 100,
        angleLines: { display: true, color: 'rgba(148, 163, 184, 0.3)' },
        grid: { display: true, color: 'rgba(148, 163, 184, 0.3)' },
        ticks: { display: false },
        pointLabels: { color: '#64748b', font: { size: 13, weight: '600' } }
      } 
    },
    plugins: {
      legend: { position: 'top', labels: { usePointStyle: true, boxWidth: 8, color: '#64748b' } }
    }
  };
  const optionsLine = { responsive: true, maintainAspectRatio: false };
  const optionsBar = { responsive: true, maintainAspectRatio: false, scales: { x: { stacked: true }, y: { stacked: true } } };

  return (
    <div className="p-8 max-w-[1600px] mx-auto space-y-8 pb-20">
      
      {/* Header & Generator Bar */}
      <div className="bg-white dark:bg-slate-900 rounded-2xl shadow-sm border border-gray-100 dark:border-slate-800 p-6">
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-6">
          <div>
            <h1 className="text-2xl font-bold text-slate-800 dark:text-white flex items-center gap-2">
              <Layers className="text-[#2996cf] w-6 h-6" />
              SEO 对比分析报告
            </h1>
            <p className="text-sm text-slate-500 mt-1">一键生成多品牌全网搜索表现、舆情阵营及拦截防御视角的战报。</p>
          </div>
          
          <div className="flex items-center gap-3">
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2">
              <div className="relative flex items-center">
                <Calendar className="w-4 h-4 absolute left-3 text-gray-500" />
                <select 
                  className="pl-9 pr-8 py-2 bg-gray-50 dark:bg-slate-800 border border-gray-200 dark:border-slate-700 rounded-lg text-slate-600 dark:text-slate-300 text-sm font-medium hover:bg-gray-100 dark:hover:bg-slate-700 transition-colors appearance-none focus:outline-none focus:ring-2 focus:ring-[#2996cf]/50"
                  value={timeRange}
                  onChange={(e) => setTimeRange(e.target.value)}
                >
                  <option value="最近 7 天">最近 7 天</option>
                  <option value="最近 30 天">最近 30 天</option>
                  <option value="本季度">本季度</option>
                </select>
                <ChevronDown className="w-4 h-4 absolute right-3 text-gray-400 pointer-events-none" />
              </div>
            </div>

            <button 
              onClick={handleGenerate}
              disabled={isGenerating}
              className={`flex items-center px-6 py-2.5 rounded-lg text-sm font-bold shadow-md transition-all ${
                isGenerating 
                  ? 'bg-gray-100 text-gray-400 cursor-not-allowed dark:bg-slate-800 dark:text-slate-500' 
                  : 'bg-gradient-to-r from-[#2996cf] to-[#1e78a6] hover:from-[#1e78a6] hover:to-[#175d82] text-white hover:shadow-lg'
              }`}
            >
              {isGenerating ? (
                <>
                  <div className="w-4 h-4 border-2 border-gray-300 border-t-gray-500 rounded-full animate-spin mr-2" />
                  生成洞察中...
                </>
              ) : (
                <>
                  <Sparkles className="w-4 h-4 mr-2" />
                  {showReport ? '重新生成' : '生成对比报告'}
                </>
              )}
            </button>

            {showReport && (
              <button 
                onClick={handleExportImage}
                className="flex items-center px-4 py-2.5 bg-emerald-50 dark:bg-emerald-900/30 text-emerald-600 dark:text-emerald-400 border border-emerald-200 dark:border-emerald-800 rounded-lg text-sm font-bold hover:bg-emerald-100 dark:hover:bg-emerald-900/50 transition-colors shadow-sm"
              >
                <Download className="w-4 h-4 mr-2" />
                导出长图
              </button>
            )}
          </div>
        </div>
      </div>

      {/* Empty State */}
      {!showReport && !isGenerating && (
        <div className="bg-white dark:bg-slate-900 rounded-2xl shadow-sm border border-dashed border-gray-300 dark:border-slate-700 p-16 flex flex-col items-center justify-center text-center">
          <div className="w-20 h-20 bg-blue-50 dark:bg-blue-900/20 rounded-full flex items-center justify-center mb-6">
            <FileText className="w-10 h-10 text-blue-300 dark:text-blue-500/50" />
          </div>
          <h3 className="text-xl font-bold text-gray-800 dark:text-slate-200 mb-2">报告尚未生成</h3>
          <p className="text-gray-500 dark:text-slate-400 max-w-md">
            请在上方选择分析时间范围，点击"生成对比报告"，系统将自动拉取各品牌数据并生成深度洞察。
          </p>
        </div>
      )}

      {/* Loading State */}
      {isGenerating && (
        <div className="bg-white dark:bg-slate-900 rounded-2xl shadow-sm border border-gray-100 dark:border-slate-800 p-16 flex flex-col items-center justify-center space-y-6">
          <div className="relative">
            <div className="w-16 h-16 border-4 border-[#2996cf]/20 rounded-full animate-pulse"></div>
            <div className="w-16 h-16 border-4 border-[#2996cf] rounded-full animate-spin absolute top-0 left-0 border-t-transparent"></div>
          </div>
          <div className="text-center">
            <h3 className="text-lg font-bold text-gray-900 dark:text-white mb-2">AI 深度分析中...</h3>
            <div className="text-sm text-gray-500 space-y-1">
              <p className="flex items-center justify-center"><Check className="w-3 h-3 mr-1 text-green-500" /> 正在拉取六维竞争力数据</p>
              <p className="flex items-center justify-center"><Check className="w-3 h-3 mr-1 text-green-500" /> 正在比对搜索阵营拦截率</p>
              <p className="flex items-center justify-center"><div className="w-3 h-3 mr-1 rounded-full bg-blue-400 animate-pulse" /> 正在生成战术建议与洞察</p>
            </div>
          </div>
        </div>
      )}

      {/* Generated Report */}
      {showReport && !isGenerating && (
        <div id="report-content" className="bg-white dark:bg-slate-900 rounded-2xl shadow-sm border border-gray-100 dark:border-slate-800 overflow-hidden">
          
          {/* Report Cover */}
          <div className="bg-gradient-to-br from-[#1e293b] to-[#0f172a] p-10 text-white relative overflow-hidden">
            <div className="absolute top-0 right-0 p-8 opacity-10 pointer-events-none">
              <Layers className="w-64 h-64" />
            </div>
            <div className="relative z-10">
              <div className="inline-flex items-center px-3 py-1 bg-white/10 rounded-full text-xs font-medium text-blue-200 mb-6 backdrop-blur-sm border border-white/10">
                <Shield className="w-3 h-3 mr-1.5" />
                SEO 竞争力洞察专报
              </div>
              <h1 className="text-4xl font-extrabold tracking-tight mb-4">{mainBrandName} vs 核心竞品 搜索防线对比分析</h1>
              <div className="flex items-center gap-6 text-slate-300 text-sm font-medium">
                <span className="flex items-center"><Calendar className="w-4 h-4 mr-2 text-slate-400" /> 报告周期: {timeRange}</span>
                <span className="flex items-center"><Target className="w-4 h-4 mr-2 text-slate-400" /> 核心目标: 阵地占位与口碑防御</span>
              </div>
            </div>
          </div>

          <div className="p-8 space-y-10">
            {/* AI Executive Summary */}
            <div className="bg-blue-50/50 dark:bg-slate-800/50 rounded-xl p-6 border border-blue-100 dark:border-slate-700/50">
              <h3 className="text-base font-bold text-gray-900 dark:text-slate-100 mb-4 flex items-center">
                <Sparkles className="w-5 h-5 mr-2 text-[#2996cf]" />
                AI 执行摘要 (Executive Summary)
              </h3>
              <div className="prose dark:prose-invert max-w-none text-sm text-gray-600 dark:text-gray-300 leading-relaxed space-y-3">
                <p>在本周期的搜索防线监测中，<strong>{mainBrandName}</strong> 的整体搜索能在各个搜索防线保持活跃。雷达图展示了品牌在提及率、能见度及防守拦截维度的综合战力。</p>
                <p>根据下方情感分布，需密切监控被标注为<strong>负面 / 吐槽 / 避坑</strong>的声量。同时，观察 SOV 趋势图，可以识别出在 {timeRange} 周期内核心竞品是否发起了集中的公关或发稿攻势。建议对波动明显的节点使用智墨一键生成正面内容进行对冲。</p>
              </div>
            </div>

            {/* Grid of Charts */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              
              {/* Radar */}
              <div>
                <h3 className="text-base font-bold text-gray-900 dark:text-slate-200 mb-4 flex items-center">
                  <Target className="w-5 h-5 mr-2 text-indigo-500" />
                  综合 SEO 竞争力六维模型
                </h3>
                <div className="h-[320px] bg-slate-50 dark:bg-slate-800/30 rounded-xl p-4 border border-slate-100 dark:border-slate-700/50">
                  <Radar data={radarData} options={optionsRadar} />
                </div>
                <div className="mt-4 p-4 bg-slate-50 dark:bg-slate-800 rounded-lg text-sm text-gray-600 dark:text-gray-400">
                  <strong>洞察:</strong> 雷达面积越饱满，代表该品牌在全链路防线（占据首屏、拦截竞品、口碑健康）上的综合控制力越强。
                </div>
              </div>

              {/* Stacked Bar - Camp */}
              <div>
                <h3 className="text-base font-bold text-gray-900 dark:text-slate-200 mb-4 flex items-center">
                  <Shield className="w-5 h-5 mr-2 text-emerald-500" />
                  搜索阵营结构对比 (口碑防线)
                </h3>
                <div className="h-[320px] bg-slate-50 dark:bg-slate-800/30 rounded-xl p-4 border border-slate-100 dark:border-slate-700/50">
                  <Bar data={campBarData} options={optionsBar} />
                </div>
                <div className="mt-4 p-4 bg-slate-50 dark:bg-slate-800 rounded-lg text-sm text-gray-600 dark:text-gray-400">
                  <strong>洞察:</strong> 蓝/绿色块代表安全的防守阵营，红/橙色块（负面/争议）占比较高的品牌需立即启动舆情公关介入。
                </div>
              </div>

            </div>

            {/* Full Width Line Chart */}
            <div>
              <h3 className="text-base font-bold text-gray-900 dark:text-slate-200 mb-4 flex items-center">
                <TrendingUp className="w-5 h-5 mr-2 text-rose-500" />
                SOV 品牌提及率长效趋势
              </h3>
              <div className="h-[300px] bg-slate-50 dark:bg-slate-800/30 rounded-xl p-4 border border-slate-100 dark:border-slate-700/50">
                <Line data={sovLineData} options={optionsLine} />
              </div>
              <div className="mt-4 p-4 bg-slate-50 dark:bg-slate-800 rounded-lg text-sm text-gray-600 dark:text-gray-400">
                <strong>洞察:</strong> 上述曲线反映了各品牌在时间轴上真实能见度（SOV）的起伏。剧烈的波峰通常对应着该品牌的一波集中发稿或热点事件。
              </div>
            </div>

            {/* Strategic Recommendations */}
            <div className="border-t border-gray-200 dark:border-slate-700 pt-8">
              <h3 className="text-base font-bold text-gray-900 dark:text-slate-100 mb-6 flex items-center">
                <Activity className="w-5 h-5 mr-2 text-orange-500" />
                下一步战术行动建议
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="bg-white dark:bg-slate-800 border-x border-b border-slate-200 dark:border-slate-700 rounded-xl p-5 shadow-sm border-t-4 border-t-[#4b75ab]">
                  <h4 className="font-bold text-[#4b75ab] mb-2">1. 巩固优势阵地</h4>
                  <p className="text-sm text-gray-600 dark:text-gray-400">继续维护高收录率的权威媒体（如汽车之家、新浪），发布季度横评和技术白皮书，锁死 Top 3 搜索位置。</p>
                </div>
                <div className="bg-white dark:bg-slate-800 border-x border-b border-slate-200 dark:border-slate-700 rounded-xl p-5 shadow-sm border-t-4 border-t-[#da9f31]">
                  <h4 className="font-bold text-[#da9f31] mb-2">2. 反制竞品拦截</h4>
                  <p className="text-sm text-gray-600 dark:text-gray-400">针对被竞品拦截的 15% 长尾词（如“静音轮胎性价比”），在知乎与小红书铺设 KOC 真实问答，挤出竞品身位。</p>
                </div>
                <div className="bg-white dark:bg-slate-800 border-x border-b border-slate-200 dark:border-slate-700 rounded-xl p-5 shadow-sm border-t-4 border-t-[#334e4c]">
                  <h4 className="font-bold text-[#334e4c] dark:text-[#afcaa6] mb-2">3. 负面舆情压制</h4>
                  <p className="text-sm text-gray-600 dark:text-gray-400">针对 B站 及 抖音 上个别的避坑/吐槽视频，建议启动智墨一键生成正面测评视频脚本，进行声量对冲与压制。</p>
                </div>
              </div>
            </div>

          </div>
        </div>
      )}
    </div>
  );
}

function Sparkles(props) {
  return (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z"/>
    </svg>
  );
}
